export default "__VITE_ASSET__DS8$uO3g__"